module.exports = __webpack_public_path__ + "img/sean.e178424c.jpeg";